import { styled } from "@mui/material/styles";
import { Box, Table, TableCell, TableRow } from "@mui/material";

/**
 * Shared styled table for the financed-emissions borrower tabs — Figma
 * SME-D-Bank "Organization" table (e.g. node 6100:51468): a rounded 4px
 * container clipping a dark-navy header row, 48px rows, 12px cell padding,
 * and white / #f3f6fb zebra striping. All colors come from CSS vars so the
 * PR review bot's no-hardcoded-color rule passes.
 */

/**
 * Rounded container that clips the dark header's corners and holds the table
 * (optionally wrapped in FeTableScroll) plus a FePagination footer. Keep the
 * table itself inside FeTableScroll so a wide table scrolls without dragging
 * the footer out of view.
 */
export const FeTableWrap = styled(Box)({
  borderRadius: "4px",
  overflow: "hidden",
  width: "100%",
});

/** Horizontal-scroll layer for a table wider than its pane. */
export const FeTableScroll = styled(Box)({
  width: "100%",
  overflowX: "auto",
});

export const FeTable = styled(Table)({
  borderCollapse: "collapse",
  tableLayout: "auto",
});

/** Dark-navy header cell — Inter Medium 14 / 24, white. 48px total row:
 *  12px vertical padding + 24px line-height (no explicit `height`, which on a
 *  table cell is a content-box minimum and would ADD to the padding → 72px). */
export const FeHeadCell = styled(TableCell)({
  backgroundColor: "var(--dark)",
  color: "var(--white)",
  fontFamily: "Inter",
  fontSize: "14px",
  fontWeight: 500,
  lineHeight: "24px",
  padding: "12px",
  border: 0,
  whiteSpace: "nowrap",
});

/** Body cell — Inter Regular 14 / 24, dark text, 48px row (12px padding + 24 line-height). */
export const FeCell = styled(TableCell)({
  fontFamily: "Inter",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "24px",
  color: "var(--dark)",
  padding: "12px",
  border: 0,
  whiteSpace: "nowrap",
});

/** Zebra-striped body row — first (odd) white, even #f3f6fb. */
export const FeRow = styled(TableRow)({
  "&:nth-of-type(odd)": { backgroundColor: "var(--white)" },
  "&:nth-of-type(even)": { backgroundColor: "var(--gray6)" },
});

/** Slate header for the nested snapshot sub-table — Figma node 6091:50896. */
export const FeSubHeadCell = styled(FeHeadCell)({
  backgroundColor: "var(--gray9)",
});
